let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dHjHz")).then(() => parcelRequire('cB0p5'));